import { settings } from 'settings';
import Fetch from 'utils/fetch';

export async function fetchRemoveInbound(inboundId: string): Promise<boolean> {
  try {
    const response: Response = await Fetch.delete({
      url: `${settings.newApiUrl}/inbound/${inboundId}`,
    });

    if (response.ok) {
      //const InboundInfoList: InboundInfo[] = await response.json();
      return true;
    }
  } catch (error) {
    return false;
  }
}
